module.exports = __webpack_public_path__ + "img/vip-level1.a5bab3c9.png";